"use client";

import { Card } from "@mui/material";
import { Formik } from "formik";

import MDBox from "@/components/atoms/MDBox";
import MDTypography from "@/components/atoms/MDTypography";
import useRecoverPassword from "@/hooks/requests/user/use-recover-password";
import { RecoverPasswordMessages } from "@/messages/recoverPassword/recover-password.messages";

import RecoverPasswordForm from "./form";
import { buildRecoverPasswordFormInitialData, buildRecoverPasswordFormSchema } from "../form-data";

type RecoverStepProps = {
  messages: RecoverPasswordMessages;
  selectedEmail: string | null;
  onSuccess: () => void;
};
export default function RecoverStep({ messages, selectedEmail, onSuccess }: RecoverStepProps) {
  const { recoverPassword, isLoading, loadingIcon } = useRecoverPassword();

  const decodedEmail = selectedEmail ? decodeURIComponent(selectedEmail) : "";

  return (
    <Card>
      <MDBox
        variant="gradient"
        bgColor="dark"
        borderRadius="lg"
        coloredShadow="dark"
        mx={2}
        mt={-3}
        py={2}
        mb={1}
        textAlign="center"
      >
        <MDTypography variant="h3" fontWeight="medium" color="white" mt={1}>
          {messages.recoverPasswordTitle}
        </MDTypography>
        <MDTypography display="block" variant="button" color="white" my={1}>
          {messages.recoverPasswordDescription}
        </MDTypography>
      </MDBox>
      <MDBox pt={4} pb={3} px={3}>
        <Formik
          initialValues={buildRecoverPasswordFormInitialData(decodedEmail)}
          validateOnChange={false}
          onSubmit={(formData) =>
            recoverPassword({
              formData,
              onSuccess,
            })
          }
          validationSchema={buildRecoverPasswordFormSchema(messages)}
        >
          <RecoverPasswordForm
            isLoading={isLoading}
            loadingIcon={loadingIcon}
            messages={messages}
          />
        </Formik>
      </MDBox>
    </Card>
  );
}
